import React from 'react';
import type {
  VulnerabilityDetailViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const VulnerabilityDetail = withErrorBoundary(
  React.lazy(
    () => import('../../../micro-frontends/components/VulnerabilityDetailView'),
  ),
);

export const VulnerabilityDetailView = (
  props: VulnerabilityDetailViewProps,
) => {
  return <VulnerabilityDetail {...props.data} inSharedSlideOver />;
};
